import{View}from'./View';/**
 * *********************************
 */export class ErrorMessage extends View{}